import { ApiBusinessError } from '@/shared/api/result';

/** 视为「未登录 / 登录态失效」的业务错误码，兼容不同后端实现。 */
const AUTH_ERROR_CODES = new Set([
  'AUTH_IP_DENIED',
  '10401',
  '401',
  '401000',
  'AUTH_EXPIRED',
  'AUTH_REQUIRED',
  'UNAUTHORIZED',
]);

/**
 * 判断错误是否为鉴权类（未登录或 token 失效）。
 * HttpError 通过结构判断，避免与 http-client 形成循环依赖。
 */
export const isAuthError = (error: unknown): boolean => {
  if (error instanceof ApiBusinessError) {
    return AUTH_ERROR_CODES.has(String(error.code));
  }
  if (error instanceof Error && error.name === 'HttpError') {
    const status = (error as { status?: number }).status;
    return status === 401 || status === 403;
  }
  return false;
};

type AuthFailureHandler = (error?: unknown) => void;

let handler: AuthFailureHandler | null = null;

/** 注册全局鉴权失败处理器：由 AppShell 注入，决定是否清会话并弹登录。 */
export const registerAuthFailureHandler = (next: AuthFailureHandler | null) => {
  handler = next;
};

/** http 层命中鉴权失败时上报，交由已注册处理器决策（缺省不做任何事）。 */
export const reportAuthFailure = (error?: unknown) => {
  handler?.(error);
};
